import { Box, Typography } from '@mui/material';
import React from 'react';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle, actions }) => {
  return (
    <Box
      sx={{
        mb: 3,
        textAlign: 'left',
        ...(actions && {
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { sm: 'flex-end' },
          justifyContent: 'space-between',
          gap: 2,
          borderBottom: 1,
          borderColor: 'divider',
          pb: 2.5,
        }),
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant={actions ? 'textXL' : 'displayMD'}
          sx={{ fontWeight: 600, letterSpacing: actions ? '-0.01em' : undefined, mb: subtitle ? (actions ? 0.5 : 1) : 0, display: 'block' }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant={actions ? 'textSM' : 'textMD'}
            color="text.secondary"
            sx={{ display: 'block', maxWidth: actions ? 720 : undefined, lineHeight: actions ? 1.6 : undefined }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, flexShrink: 0 }}>
          {actions}
        </Box>
      )}
    </Box>
  );
};

export default PageTitle;
